import { render, staticRenderFns } from "./AddESGDataLogBottomSheet.vue?vue&type=template&id=670a770c"
import script from "./AddESGDataLogBottomSheet.vue?vue&type=script&lang=js"
export * from "./AddESGDataLogBottomSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports